import type {
  Mailbox,
  MailboxMember,
  MailboxCreateInput,
  MailboxUpdateInput,
  TestConnectionResult,
} from "@cdt/shared";

import { api } from "@/lib/api";

export type { Mailbox, MailboxMember, MailboxCreateInput, MailboxUpdateInput, TestConnectionResult };

export async function fetchMailboxes(): Promise<{ items: Mailbox[] }> {
  return api.get<{ items: Mailbox[] }>("/api/mailboxes");
}

export async function fetchMyMailboxes(): Promise<{ items: Mailbox[] }> {
  return api.get<{ items: Mailbox[] }>("/api/me/mailboxes");
}

export async function createMailbox(input: MailboxCreateInput): Promise<Mailbox> {
  return api.post<Mailbox>("/api/mailboxes", input);
}

export async function updateMailbox(
  id: string,
  input: MailboxUpdateInput,
): Promise<Mailbox> {
  return api.patch<Mailbox>(`/api/mailboxes/${encodeURIComponent(id)}`, input);
}

export async function testMailboxConnection(
  id: string,
): Promise<TestConnectionResult> {
  return api.post<TestConnectionResult>(
    `/api/mailboxes/${encodeURIComponent(id)}/test-connection`,
  );
}

export async function addMailboxMember(
  mailboxId: string,
  userId: string,
): Promise<Mailbox> {
  return api.post<Mailbox>(
    `/api/mailboxes/${encodeURIComponent(mailboxId)}/members`,
    { userId },
  );
}

export async function removeMailboxMember(
  mailboxId: string,
  userId: string,
): Promise<Mailbox> {
  return api.delete<Mailbox>(
    `/api/mailboxes/${encodeURIComponent(mailboxId)}/members/${encodeURIComponent(userId)}`,
  );
}
